import axios from 'axios'

export default {
  install (Vue) {
    Vue.prototype.$http = axios
    Vue.http = axios
  },
  $http: axios
}



// WEBPACK FOOTER //
// ./src/plugins/ajax/index.js